import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-success-profile',
    templateUrl: './success-profile.component.html',
    styleUrls: ['./success-profile.component.scss'],
    standalone: false
})
export class SuccessProfileComponent {

  constructor(private readonly router: Router) { }

  navigateLogin() {
    this.router.navigate(['login']);
  }
}
